import { FaUser, FaMars, FaVenus, FaEdit, FaArrowLeft, FaBirthdayCake, FaCheck } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import { clientInfo, updateClientInfo } from "../services/ClientProfileService"
import { useSelector } from 'react-redux';
import { showToast } from 'toast/toastHelper';
import { useTranslation } from "react-i18next";

const ClientEdit = () => {

  const { t } = useTranslation(["client"]);

  const accessToken = useSelector((state) => state.auth.accessToken);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: 2,
    year: "1370",
    month: "01",
    day: "01",
  });
  const [buttonText, setButtonText] = useState(t("editProfile.editButton"));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchClientInfo = async () => {
      try {
        const res = await clientInfo({ accessToken })
        if (res?.ok) {
          if (res.data.isProfileComplete) {
            const profile = res.data;
            let year = "1370", month = "01", day = "01";

            if (profile.birthDate) {
              [year, month, day] = profile.birthDate.split("-");
            }

            setFormData({
              firstName: profile.firstName || "",
              lastName: profile.lastName || "",
              gender: profile.gender ?? 2,
              year, month, day,
            });
          } else {
            setButtonText(t("editProfile.submitButton"));
          }
        }
      } catch (error) { }
    };
    fetchClientInfo();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "firstName" || name === "lastName") {
      if (!/^[\u0600-\u06FF\s]*$/.test(value)) return;
    }
    setFormData((prev) => ({
      ...prev,
      [name]: name === "gender" ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      gender: formData.gender,
      birthDate: `${formData.year}-${formData.month}-${formData.day}`,
    };
    try {
      const res = await updateClientInfo({ accessToken, data });
      if (res?.ok) {
        showToast(t("editProfile.successMessage"), "success");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const years = [];
  for (let i = 1420; i >= 1300; i--) years.push(i);

  const monthKeys = [
    '01', '02', '03', '04', '05', '06',
    '07', '08', '09', '10', '11', '12'
  ];

  const days = [];
  for (let i = 1; i <= 31; i++) days.push(i.toString().padStart(2, '0'));

  const initials = `${formData.firstName?.[0] || ''}${formData.lastName?.[0] || ''}` || '؟';

  return (
    <div className="min-h-screen w-full flex items-center justify-center px-3 sm:px-4 py-6 sm:py-10 bg-gradient-to-br from-[#eaf6f4] via-white to-[#eaf6f4] dark:!from-[#121818] dark:!via-[#18181b] dark:!to-[#121818] transition-colors duration-300">
      <div className="w-full max-w-2xl">
        {/* Form Card */}
        <form
          onSubmit={handleSubmit}
          className="bg-white dark:!bg-gray-900 rounded-3xl shadow-xl dark:!shadow-black/40 border border-gray-100 dark:!border-gray-800 overflow-hidden"
        >

          {/* Personal Info Section */}
          <div className="p-5 sm:p-7">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-8 h-8 rounded-lg bg-teal-50 dark:!bg-teal-950/60 flex items-center justify-center">
                <FaUser className="w-3.5 h-3.5 text-teal-600 dark:!text-teal-400" />
              </div>
              <h3 className="text-sm font-bold text-gray-800 dark:!text-gray-100">
                {t("editProfile.sections.personalInfo")}
              </h3>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-semibold text-gray-600 dark:!text-gray-400 mb-2">
                  {t("editProfile.firstName")}
                </label>
                <div className="relative">
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    className="w-full px-4 py-3 pr-11 border-2 border-gray-200 dark:!border-gray-700 rounded-xl bg-gray-50 dark:!bg-gray-800 focus:border-teal-500 dark:!focus:border-teal-500 focus:ring-2 focus:ring-teal-200 dark:!focus:ring-teal-900/60 focus:bg-white dark:!focus:bg-gray-800 outline-none transition-all duration-300 text-gray-700 dark:!text-gray-100 font-medium placeholder:text-gray-400 dark:!placeholder:text-gray-500 text-sm"
                    placeholder={t("editProfile.firstNamePlaceholder")}
                  />
                  <FaUser className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:!text-gray-500 w-4 h-4" />
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 dark:!text-gray-400 mb-2">
                  {t("editProfile.lastName")}
                </label>
                <div className="relative">
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    className="w-full px-4 py-3 pr-11 border-2 border-gray-200 dark:!border-gray-700 rounded-xl bg-gray-50 dark:!bg-gray-800 focus:border-teal-500 dark:!focus:border-teal-500 focus:ring-2 focus:ring-teal-200 dark:!focus:ring-teal-900/60 focus:bg-white dark:!focus:bg-gray-800 outline-none transition-all duration-300 text-gray-700 dark:!text-gray-100 font-medium placeholder:text-gray-400 dark:!placeholder:text-gray-500 text-sm"
                    placeholder={t("editProfile.lastNamePlaceholder")}
                  />
                  <FaUser className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:!text-gray-500 w-4 h-4" />
                </div>
              </div>
            </div>
          </div>

          <div className="h-px bg-gray-100 dark:!bg-gray-800"></div>

          {/* Gender Section */}
          <div className="p-5 sm:p-7">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-8 h-8 rounded-lg bg-teal-50 dark:!bg-teal-950/60 flex items-center justify-center">
                <FaMars className="w-3.5 h-3.5 text-teal-600 dark:!text-teal-400" />
              </div>
              <h3 className="text-sm font-bold text-gray-800 dark:!text-gray-100">
                {t("editProfile.sections.gender")}
              </h3>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <label className={`relative flex items-center justify-center gap-2 px-4 py-3.5 border-2 rounded-xl cursor-pointer transition-all duration-300 ${formData.gender === 2
                  ? 'border-teal-500 bg-teal-50 dark:!bg-teal-950/40 dark:!border-teal-500 shadow-md shadow-teal-100 dark:!shadow-teal-900/30'
                  : 'border-gray-200 dark:!border-gray-700 bg-gray-50 dark:!bg-gray-800 hover:border-teal-300 dark:!hover:border-teal-600'
                }`}>
                <input
                  type="radio"
                  name="gender"
                  value={2}
                  checked={formData.gender === 2}
                  onChange={handleChange}
                  className='sr-only'
                />
                <FaMars className={`w-5 h-5 ${formData.gender === 2
                    ? 'text-teal-600 dark:!text-teal-400'
                    : 'text-gray-400 dark:!text-gray-500'
                  }`} />
                <span className={`text-sm font-bold ${formData.gender === 2
                    ? 'text-teal-700 dark:!text-teal-300'
                    : 'text-gray-600 dark:!text-gray-400'
                  }`}>
                  {t("editProfile.male")}
                </span>
                {formData.gender === 2 && (
                  <div className="absolute top-2 right-2 w-4 h-4 rounded-full bg-teal-500 flex items-center justify-center">
                    <FaCheck className="w-2 h-2 text-white" />
                  </div>
                )}
              </label>

              <label className={`relative flex items-center justify-center gap-2 px-4 py-3.5 border-2 rounded-xl cursor-pointer transition-all duration-300 ${formData.gender === 1
                  ? 'border-pink-500 bg-pink-50 dark:!bg-pink-950/40 dark:!border-pink-500 shadow-md shadow-pink-100 dark:!shadow-pink-900/30'
                  : 'border-gray-200 dark:!border-gray-700 bg-gray-50 dark:!bg-gray-800 hover:border-pink-300 dark:!hover:border-pink-600'
                }`}>
                <input
                  type="radio"
                  name="gender"
                  value={1}
                  checked={formData.gender === 1}
                  onChange={handleChange}
                  className='sr-only'
                />
                <FaVenus className={`w-5 h-5 ${formData.gender === 1
                    ? 'text-pink-600 dark:!text-pink-400'
                    : 'text-gray-400 dark:!text-gray-500'
                  }`} />
                <span className={`text-sm font-bold ${formData.gender === 1
                    ? 'text-pink-700 dark:!text-pink-300'
                    : 'text-gray-600 dark:!text-gray-400'
                  }`}>
                  {t("editProfile.female")}
                </span>
                {formData.gender === 1 && (
                  <div className="absolute top-2 right-2 w-4 h-4 rounded-full bg-pink-500 flex items-center justify-center">
                    <FaCheck className="w-2 h-2 text-white" />
                  </div>
                )}
              </label>
            </div>
          </div>

          <div className="h-px bg-gray-100 dark:!bg-gray-800"></div>

          {/* Birth Date Section */}
          <div className="p-5 sm:p-7">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-8 h-8 rounded-lg bg-teal-50 dark:!bg-teal-950/60 flex items-center justify-center">
                <FaBirthdayCake className="w-3.5 h-3.5 text-teal-600 dark:!text-teal-400" />
              </div>
              <h3 className="text-sm font-bold text-gray-800 dark:!text-gray-100">
                {t("editProfile.sections.birthDate")}
              </h3>
            </div>

            <div className="grid grid-cols-3 gap-2 sm:gap-3">
              <div>
                <label className="block text-[11px] text-gray-500 dark:!text-gray-400 mb-1.5 font-medium">
                  {t("editProfile.year")}
                </label>
                <select
                  name="year"
                  value={formData.year}
                  onChange={handleChange}
                  className="w-full px-2 sm:px-3 py-2.5 border-2 border-gray-200 dark:!border-gray-700 rounded-xl bg-gray-50 dark:!bg-gray-800 focus:border-teal-500 dark:!focus:border-teal-500 focus:ring-2 focus:ring-teal-200 dark:!focus:ring-teal-900/60 outline-none transition-all duration-300 text-gray-700 dark:!text-gray-100 text-sm font-medium appearance-none cursor-pointer hover:border-teal-300 dark:!hover:border-teal-600 text-center"
                >
                  {years.map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-[11px] text-gray-500 dark:!text-gray-400 mb-1.5 font-medium">
                  {t("editProfile.month")}
                </label>
                <select
                  name="month"
                  value={formData.month}
                  onChange={handleChange}
                  className="w-full px-2 sm:px-3 py-2.5 border-2 border-gray-200 dark:!border-gray-700 rounded-xl bg-gray-50 dark:!bg-gray-800 focus:border-teal-500 dark:!focus:border-teal-500 focus:ring-2 focus:ring-teal-200 dark:!focus:ring-teal-900/60 outline-none transition-all duration-300 text-gray-700 dark:!text-gray-100 text-sm font-medium appearance-none cursor-pointer hover:border-teal-300 dark:!hover:border-teal-600 text-center"
                >
                  {monthKeys.map((key) => (
                    <option key={key} value={key}>
                      {t(`editProfile.months.${key}`)}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-[11px] text-gray-500 dark:!text-gray-400 mb-1.5 font-medium">
                  {t("editProfile.day")}
                </label>
                <select
                  name="day"
                  value={formData.day}
                  onChange={handleChange}
                  className="w-full px-2 sm:px-3 py-2.5 border-2 border-gray-200 dark:!border-gray-700 rounded-xl bg-gray-50 dark:!bg-gray-800 focus:border-teal-500 dark:!focus:border-teal-500 focus:ring-2 focus:ring-teal-200 dark:!focus:ring-teal-900/60 outline-none transition-all duration-300 text-gray-700 dark:!text-gray-100 text-sm font-medium appearance-none cursor-pointer hover:border-teal-300 dark:!hover:border-teal-600 text-center"
                >
                  {days.map(day => (
                    <option key={day} value={day}>{day}</option>
                  ))}
                </select>
              </div>
            </div>

            <p className="text-[11px] text-gray-400 dark:!text-gray-500 mt-2.5 flex items-center gap-1">
              <span className="w-1 h-1 rounded-full bg-teal-500"></span>
              {t("editProfile.birthDateHint")}
            </p>
          </div>

          {/* Submit Button */}
          <div className="px-5 sm:px-7 pb-5 sm:pb-7">
            <button
              type="submit"
              disabled={loading}
              className="w-full py-4 bg-gradient-to-r from-teal-600 to-teal-700 dark:!from-teal-700 dark:!to-teal-800 text-white font-bold rounded-2xl shadow-lg shadow-teal-200/60 dark:!shadow-black/40 hover:shadow-xl hover:shadow-teal-300/60 dark:!hover:shadow-black/60 transform hover:scale-[1.01] active:scale-[0.99] transition-all duration-300 flex items-center justify-center gap-3 group disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {loading ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>{t("editProfile.saving")}</span>
                </>
              ) : (
                <>
                  <FaEdit className="w-4 h-4 transition-transform group-hover:rotate-12" />
                  <span>{buttonText}</span>
                </>
              )}
            </button>
          </div>
        </form>

        {/* Footer note */}
        <p className="text-center text-[11px] text-gray-400 dark:!text-gray-500 mt-4">
          {t("editProfile.footerNote")}
        </p>
      </div>
    </div>
  );
};

export default ClientEdit;